var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChrome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5005 46.4987C40.0613 46.4987 47.0012 39.5588 47.0012 30.998C47.0012 22.4372 40.0613 15.4973 31.5005 15.4973C22.9396 15.4973 15.9998 22.4372 15.9998 30.998C15.9998 39.5588 22.9396 46.4987 31.5005 46.4987Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0764 38.752L4.65456 15.5046C1.93306 20.2169 0.500188 25.5626 0.5 31.0043C0.499812 36.4459 1.93232 41.7918 4.65349 46.5042C7.37467 51.2166 11.2886 55.1296 16.0017 57.8496C20.7148 60.5696 26.0609 62.0008 31.5026 61.9993L44.9244 38.752V38.7479C43.565 41.1054 41.6088 43.0633 39.2525 44.4247C36.8962 45.7861 34.2229 46.5031 31.5016 46.5035C28.7803 46.5039 26.1068 45.7878 23.7501 44.427C21.3935 43.0663 19.4365 41.109 18.0764 38.752Z",
    fill: "url(#paint0_linear_18_16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9235 38.7509L31.5018 61.9982C36.9434 61.999 42.2894 60.567 47.0021 57.8463C51.7148 55.1257 55.6281 51.2122 58.3487 46.4994C61.0691 41.7865 62.5009 36.4405 62.5 30.9988C62.499 25.5571 61.0654 20.2117 58.3432 15.4998H31.4995L31.4962 15.5018C34.2175 15.5004 36.8912 16.2157 39.2484 17.5756C41.6056 18.9355 43.5631 20.892 44.9241 23.2486C46.2851 25.6051 47.0016 28.2785 47.0016 30.9998C47.0015 33.7211 46.2846 36.3944 44.9235 38.7509Z",
    fill: "url(#paint1_linear_18_16)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5004 43.2729C38.2777 43.2729 43.7718 37.7787 43.7718 31.0014C43.7718 24.2241 38.2777 18.73 31.5004 18.73C24.7231 18.73 19.2291 24.2241 19.2291 31.0014C19.2291 37.7787 24.7231 43.2729 31.5004 43.2729Z",
    fill: "#1A73E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5005 15.5007H58.3442C55.6239 10.7877 51.7109 6.87392 46.9984 4.15292C42.2859 1.43193 36.9399 -0.00038614 31.4982 7.8086e-08C26.0566 0.000386297 20.7109 1.43346 15.9988 4.15512C11.2866 6.87678 7.37411 10.7911 4.6546 15.5044L18.0764 38.7518L18.0798 38.7536C16.7181 36.3975 16.0006 33.7245 15.9997 31.0032C15.9988 28.2819 16.7146 25.6082 18.0749 23.2514C19.4352 20.8945 21.3922 18.9372 23.7489 17.5767C26.1057 16.2161 28.7792 15.5001 31.5005 15.5007Z",
    fill: "url(#paint2_linear_18_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_16",
    x1: 34.8562,
    y1: 60.0631,
    x2: 8.01144,
    y2: 13.5666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_16",
    x1: 26.9785,
    y1: 62.0804,
    x2: 53.8233,
    y2: 15.5839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_16",
    x1: 4.65461,
    y1: 19.3768,
    x2: 58.3442,
    y2: 19.3768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.c488eecd0a77e143909043667a9d9d92.svg";
export { ForwardRef as ReactComponent };